import { IDbscanPoint } from '@src/slide/application/service/slide-content-layout-analyzer/core/algorithm/data-structure/dbscan';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { IPoint } from '@src/slide/infrastructure/module/independent/graphic/point/point.interface';
import { getPointsAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { Polygon } from '@src/slide/infrastructure/module/independent/graphic/polygon/polygon';
import { IElementNode } from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer.interface';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

export class ContentRect implements IDbscanPoint {
    public frame: IFrame;
    public polygon: Polygon;
    private elementNode: IElementNode;
    private textRect?: IRect;

    public constructor(elementNode: IElementNode, textRect?: IRect) {
        this.elementNode = elementNode;
        this.frame = this.elementNode.element.getFrame().frameOnSlide();
        this.textRect = textRect;
        this.polygon = this.generatePolygon();
    }

    public distanceTo(data: ContentRect): number {
        return this.polygon.distanceToPolygon(data.polygon);
    }

    private generatePolygon(): Polygon {
        let points: Array<IPoint>;
        if (this.frame.rotate && this.frame.rotate !== 0) {
            const center = {
                x: (this.frame.left + this.frame.left + this.frame.width) / 2,
                y: (this.frame.top + this.frame.top + this.frame.height) / 2,
            };
            if (this.textRect) {
                const rect = {
                    left: this.frame.left + this.textRect.left,
                    top: this.frame.top + this.textRect.top,
                    width: this.textRect.width,
                    height: this.textRect.height,
                };
                points = getPointsAfterRotate(rect, this.frame.rotate, center);
            } else {
                points = getPointsAfterRotate(this.frame, this.frame.rotate, center);
            }
        } else {
            points = [];
            if (this.textRect) {
                points.push({ x: this.frame.left + this.textRect.left,
                    y: this.frame.top + this.textRect.top });
                points.push({ x: this.frame.left + this.textRect.left + this.textRect.width,
                    y: this.frame.top + this.textRect.top });
                points.push({ x: this.frame.left + this.textRect.left + this.textRect.width,
                    y: this.frame.top + this.textRect.top + this.textRect.height });
                points.push({ x: this.frame.left + this.textRect.left,
                    y: this.frame.top + this.textRect.top + this.textRect.height });
            } else {
                points.push({ x: this.frame.left, y: this.frame.top });
                points.push({ x: this.frame.left + this.frame.width, y: this.frame.top });
                points.push({ x: this.frame.left + this.frame.width, y: this.frame.top + this.frame.height });
                points.push({ x: this.frame.left, y: this.frame.top + this.frame.height });
            }
        }
        return new Polygon(points);
    }
}
